// CSRF token management service
class CSRFService {
  private token: string | null = null;
  private tokenPromise: Promise<string> | null = null;

  async getToken(): Promise<string> {
    if (this.token) {
      return this.token;
    }

    if (this.tokenPromise) {
      return this.tokenPromise;
    }

    this.tokenPromise = this.fetchToken();
    this.token = await this.tokenPromise;
    this.tokenPromise = null;
    
    return this.token;
  }

  private async fetchToken(): Promise<string> {
    const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:3002').replace(/\/+$/, '');
    
    const response = await fetch(`${API_BASE_URL}/api/csrf-token`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Origin': window.location.origin
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch CSRF token');
    }

    const { csrfToken } = await response.json();
    return csrfToken;
  }

  clearToken() {
    this.token = null;
    this.tokenPromise = null;
  }
}

export const csrfService = new CSRFService();